module.exports = __webpack_public_path__ + "static/media/profile-gradient.6865c716.webp";